import React, { useState, useEffect } from 'react'; 
import styled from 'styled-components';
import { Title, Text } from '../../UI/Typography';
import { Button } from '../../UI/Buttons';
import { getAllUsers } from '../../../Services/Api/userService'; 
import UserTable from '../Usermanagementcomponents/UserTable'; 
import UserRegisterForm from '../Usermanagementcomponents/Userregisterform'; 
import UserEditForm from '../Usermanagementcomponents/UserEditForm'; 
import Modal from '../Usermanagementcomponents/Modal'; 
import { useAuth } from '../../../Context/AuthContext';
import { usePopup } from '../../../Popups/PopupContext'; // Add this import at the top

const PageContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.lg};
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const DrawButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.text.inverse};
  
  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.secondary};
  }
`;

function UserManagementMain() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false); 
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedUserForEdit, setSelectedUserForEdit] = useState(null);
  const { showError } = usePopup(); // Add this line 

  const refreshUsers = async () => {
    setIsLoading(true);
    setError(null);
    try {
      if (!user?.company?.id) throw new Error('No company ID found for current user.');
      const fetchedUsers = await getAllUsers(user.company.id);
      setUsers(fetchedUsers);
    } catch (err) {
      const errorMessage = err.message || 'Failed to reload users.';
      setError(errorMessage);
      
      // Replace console.error with custom popup
      showError('Failed to Load Users', errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    refreshUsers(); 
  }, []); 

  const openRegisterModal = () => setIsRegisterModalOpen(true);
  const closeRegisterModal = () => setIsRegisterModalOpen(false);
  const handleSuccessfulRegistration = () => {
    refreshUsers();
    closeRegisterModal(); 
  };

  const openEditModal = (user) => {
    setSelectedUserForEdit(user);
    setIsEditModalOpen(true);
  };
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedUserForEdit(null); 
  };
  const handleSuccessfulUpdate = () => {
    refreshUsers();
    closeEditModal(); 
  };

  return (
    <PageContainer>
      <HeaderContainer>
        <Title>User Management</Title>
        <DrawButton onClick={openRegisterModal}>Register New User</DrawButton> 
      </HeaderContainer>
      
      {isLoading && <Text style={{ padding: '1rem' }}>Loading users...</Text>}
      {error && <Text style={{ padding: '1rem' }} color="error">Error: {error}</Text>}
      {!isLoading && !error && (
        <UserTable 
          users={users} 
          onRefresh={refreshUsers} 
          onEdit={openEditModal} 
        />
      )} 
      
      <Modal isOpen={isRegisterModalOpen} onClose={closeRegisterModal}>
        <UserRegisterForm 
          onSuccessfulSubmit={handleSuccessfulRegistration} 
          onClose={closeRegisterModal} 
        />
      </Modal>

      <Modal isOpen={isEditModalOpen} onClose={closeEditModal}>
        <UserEditForm 
          userToEdit={selectedUserForEdit}
          onSuccessfulUpdate={handleSuccessfulUpdate} 
          onClose={closeEditModal} 
        />
      </Modal>
    </PageContainer>
  );
}

export default UserManagementMain;
